"use client";

import { CertificatesDisplay } from "@/features/profile/tutor/components/profile-page/CertificatesSection/CertificatesDisplay.tsx";

export function CertificatesSection() {
  return (
    <div>
      <CertificatesDisplay />
    </div>
  );
}
